import { useTheme } from "@rentiohq/web-shared-next/dist/themes";

export const AddBankAccountStyles = () => {
  const theme = useTheme();
  return {
    content: {
      heading: {
        color: theme.palette.grey[900],
      },
    },
  };
};
